import { render } from "./HistorySettings.vue?vue&type=template&id=b28183e4&scoped=true&ts=true"
import script from "./HistorySettings.vue?vue&type=script&lang=ts"
export * from "./HistorySettings.vue?vue&type=script&lang=ts"

import "./HistorySettings.vue?vue&type=style&index=0&id=b28183e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b28183e4"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QToggle,QSelect,QBtn});
